/**
 * Resolve image URL from API response.
 * Local CMS uploads are rewritten to same-origin /backend-twa/uploads/...
 * so the React dev server can proxy them (localhost vs 127.0.0.1 breaks CSS backgrounds).
 */
export function getImageUrl(image, legacyFolder = 'tour') {
  if (!image) {
    return '';
  }

  const localUpload = String(image).match(
    /^https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?(\/backend-twa\/uploads\/.+)$/i
  );
  if (localUpload) {
    return localUpload[1];
  }

  if (
    image.startsWith('http://') ||
    image.startsWith('https://') ||
    image.startsWith('data:') ||
    image.startsWith('/')
  ) {
    return image;
  }

  // CMS uploads are stored as folder/filename.jpg
  if (image.includes('/')) {
    return `/backend-twa/uploads/${image.replace(/^\/+/, '')}`;
  }

  return `/assets/img/${legacyFolder}/${image}`;
}

/** Rewrite img src values inside CMS HTML so local/prod upload paths resolve. */
export function rewriteHtmlMedia(html, legacyFolder = 'blog') {
  if (!html) {
    return '';
  }

  return String(html).replace(/<img\b([^>]*?)>/gi, (tag, attrs) => {
    const srcMatch = attrs.match(/\ssrc=(["'])(.*?)\1/i);
    if (!srcMatch) {
      return tag;
    }
    const nextSrc = getImageUrl(srcMatch[2], legacyFolder);
    if (!nextSrc || nextSrc === srcMatch[2]) {
      return tag;
    }
    return tag.replace(srcMatch[0], ` src=${srcMatch[1]}${nextSrc}${srcMatch[1]}`);
  });
}

export default getImageUrl;
